// File: src/Login.js - Update the navigation

import React, { useState } from 'react';
import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      localStorage.setItem('userId', user.uid);
      const token = await user.getIdToken();
      localStorage.setItem('userToken', token);
  
      console.log("✅ Login successful:", user);
  
      if (typeof onLoginSuccess === "function") {
        onLoginSuccess(user);
      } else {
        console.error("❌ Error: onLoginSuccess is undefined or not a function");
      }
  
      navigate('/overview');  // Redirect to overview dashboard
    } catch (error) {
      console.error("❌ Login failed:", error.message);
      setError("Invalid login credentials. Please try again.");
    }
  };

  return (
    <div>
      <h2>Login</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <form onSubmit={handleLogin}>
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit">Login</button>
      </form>
      <p>Don't have an account? <a href="/register">Register here</a></p>
    </div>
  );
};

export default Login;